import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* 	Utility function, split an array into two
 *  @function partition
 *  @param {array} array  - A source array of values
 *  @param {function} isValid - Comparator function that returns true/fase
 * 	@returns {array} - returns two partitioned arrays
 */
var partition = function partition(array, isValid) {
  return array.reduce(function (_ref, elem) {
    var _ref2 = _slicedToArray(_ref, 2),
      pass = _ref2[0],
      fail = _ref2[1];
    return isValid(elem) ? [[].concat(_toConsumableArray(pass), [elem]), fail] : [pass, [].concat(_toConsumableArray(fail), [elem])];
  }, [[], []]);
};

/*  Utility function, Returns a date as a Unix timestamp
 *  @function getEpoch
 *  @param {string} dateValue  - A valid date: 12/31/2001
 *  @returns {number} - A unix timestamp for the input date
 */
var getEpoch = function getEpoch(dateValue) {
  return parseInt((new Date(dateValue).getTime() / 1000).toFixed(0));
};

/**
 * reduceObjectByDefinedAttributes, filter out key pair if the value is undefined
 * @param {any} objectToBeReduced
 * @returns {any}
 */

var reduceObjectByDefinedAttributes = function reduceObjectByDefinedAttributes(objectToBeReduced) {
  return objectToBeReduced && Object.keys(objectToBeReduced).reduce(function (acc, currKey) {
    var currObjectToBeReducedValue = objectToBeReduced[currKey];
    if (currObjectToBeReducedValue === undefined) {
      return acc;
    }
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, currKey, currObjectToBeReducedValue));
  }, {});
};

export { getEpoch, partition, reduceObjectByDefinedAttributes };
